<template>
  <div>

    <div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;overflow: hidden;">
      <img style="object-fit: cover;width: calc(100% - 350px);height: 100%;" src="../../assets/img/login.png">
    </div>



    <div class="rightContent">
      <div class="rightContent-body" v-if="!multipleCheck" >
        <div class="localAccount">
          <img
              style="width: 90%; height: 18%"
              src="../../assets/img/icontitle_1.png"
          />
          <h1>{{ $t("login.dashboardPortal") }}</h1>

          <h2>{{ $t("login.loginTitle1") }}</h2>
          <p class="infoError" v-if="isError">
            {{ $t("login.UserPasswordError") }}
          </p>
          <a-form :form="form">
            <a-col style="text-align: left; font-size: 18px">{{
                $t("login.Username")
              }}</a-col>
            <a-form-item>
              <a-input
                  @pressEnter="handleSubmit"
                  allowClear
                  style="font-size: 16px"
                  v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.PleaseUsername'),
                      },
                    ],
                  },
                ]"
              >
              </a-input>
            </a-form-item>
            <a-col style="text-align: left; font-size: 18px">{{
                $t("login.Password")
              }}</a-col>
            <a-form-item>
              <a-input
                  style="font-size: 16px"
                  allowClear
                  v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.PleasePassword'),
                      },
                    ],
                  },
                ]"
                  type="password"
                  @pressEnter="handleSubmit"
              >
              </a-input>
            </a-form-item>

            <a-col style="text-align: left; font-size: 18px">{{$t("login.language")}}</a-col>
            <a-form-item>
              <a-select
                  v-model="languageSelect"
                  style="width: 100%"
                  showSearch
                  optionFilterProp="children"
                  @change="selectLanguages"
              >
                <a-select-option
                    v-for="(item, index) in languages"
                    :value="item.code"
                    :key="index"
                >{{ item.code }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-form>


          <a-row type="flex" justify="space-between" style="margin: 15px 0">
            <a-col style="width: 100%">
              <a-button
                  id="loginBtnSign"
                  size="large"
                  style="width: 100%; background-color: #2C2C2C"
                  :loading="loginLoading"
                  @click="handleSubmit"
                  type="primary"
              >{{ $t("login.SignIn") }}</a-button
              >
            </a-col>
          </a-row>

          <a-row style="margin-top: 20px">
            <p class="infoError" v-if="noReprotError">
              {{ $t("login.noReportIsSetupForThisAccount") }}
            </p>
          </a-row>

        </div>

        <a-row id="login_footer" style="bottom: 0;margin-bottom: 20px;margin-right: 40px" type="flex" justify="center">
          <img
              style="width: 60%; height: 60%"
              src="../../assets/img/dp_world_logo_black.png"
          />
        </a-row>

      </div>







    </div>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import cookie from "../../api/cookie";
import moment from "moment";
import CryptoJS from '../../assets/js/crypto-js.min.js';
import sessionManager from "../../utils/session-manager";
export default {
  data() {
    return {
      clientHeight: 0, // 声明data
      form: this.$form.createForm(this), // 表单注册
      keepMeSigned: false, // 是否保持登录
      trustBrowser:false,//是否信任浏览器   信任浏览器14天内不需要再输入验证码
      isError: false, // 提示信息
      noReprotError:false,
      multipleCheck: false,
      verificationCode: null,
      qrPassword:'',
      timeZone:'',
      trustBrowserTime:'',
      verificationCodeError: false,
      authenticatorCheck:false,
      disabledCheck:false,
      verificationCodeErrorMsg: '',
      verifyQRError: false,
      verifyQRErrorMsg: '',
      verifyQRErrorMsg2: '',
      title11:'',
      msgColor:'',
      lang: true, // 语言
      loginLoading: false,
      mobileNum: '',
      useredQr: 'N',
      secretQr: '',
      sendMsgShow: '' ,
      sendEmailShow: '' ,
      time:0,
      authorizationCode: '',
      userName:'',
      // showSecret:false,
      qrCode:'',
      disableColor:'',
      btnDisableColor:'#52b7e3',
      languages: [
        {
          code: "English",
          codeDesc: "English"
        },
        {
          code: "한국어 / Korean",
          codeDesc: "한국어 / Korean"
        },
        {
          code: "日本語 / Japanese",
          codeDesc: "日本語 / Japanese"
        },
        {
          code: "简体中文 / S. Chinese",
          codeDesc: "简体中文 / S. Chinese"
        },
        {
          code: "繁體中文 / T. Chinese",
          codeDesc: "繁體中文 / T. Chinese"
        },
      ],
      userEmailList:[],
      languageSelect:'',
    };
  },
  created() {
    //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
    this.languageSelect = this.languages[0].code; // 设置默认值
    this.$i18n.locale = "en";
  },
  mounted() { //监控页面高度
    var _this = this;
    // 挂载读取页面高度
    _this.setClientHight();
    // 窗口页面高度变更
    window.onresize = function () {
      _this.setClientHight();
    }
  },
  watch: {
    verificationCode: {
      handler(newVal) {
        this.verificationCodeError = false
      },
      deep: true,　　immediate: false,
    }
  }
  ,
  methods:
      {



        setClientHight() { // 当页面高度发生变化触发事件
          var _this = this;
          _this.clientHeight = `${document.documentElement.clientHeight}`; //设置页面高度
          var doc = document.getElementById('login_footer');
          if (doc != undefined && doc != 'null') {
            if (_this.clientHeight > 490) {
              doc.style.position = 'fixed';
            } else {
              doc.style.position = 'static';
            }
          }
        },


        encryptByDES(message,key) {
          var keyHex = CryptoJS.enc.Utf8.parse(key);
          //  console.log("keyHex:"+keyHex)
          var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          return encrypted.toString();
        },




        //        提交
        handleSubmit() {
          let that = this;
          this.form.validateFields((err, values) => {
            if (!err) {
              this.loginLoading = true;
              let utcTime = moment.utc().valueOf();
              values['password'] = this.encryptByDES(values['password'],Math.floor(utcTime/ 30000).toString())
              values['timestamp'] = utcTime;
              //  console.info( values['password'])
              //  console.info(utcTime)
              ajax.post(api.AUTHORIZATIONCODE + "?from=PC", values).then((res) => {
                this.loginLoading = false;
                if (res.code == 200) {
                  this.userName = values.username;

                  ajax.post(api.LOGINAPI + "?from=PC", values).then((res) => {
                    this.loginLoading = false;
                    if (res.code == 200) {

                      let token = res.data;
                      if (typeof token === 'string' && token.startsWith("Bearer ")) {
                        token = token.replace("Bearer ", "");
                      }
                      sessionStorage.setItem("logout", "/dashboard/login");
                      sessionStorage.setItem("token", token);

                      let localLanguage = this.$i18n.locale;
                      let languageSelect = that.languageSelectChange(localLanguage);

                      values.language = languageSelect;
                      ajax.post(api.INVENTORYDPWDASHBOARDINFO, values).then((res) => {
                        if (res.code == 200) {
                          let returnData = res.data;
                          if(null == returnData || returnData.length == 0) {
                            this.noReprotError = true;

                            sessionManager.clearUserData();
                            return;
                          }

                          this.$router.push({
                            path: "/dashboard/home"
                          });
                        } else {
                          this.noReprotError = true;
                          sessionManager.clearUserData();
                        }

                      });


                    } else {
                      this.isError = true;
                    }
                  });
                } else {
                  this.isError = true;
                }
              });
            }
          });
        },

        selectLanguages(langUser) {
          if(langUser == "English"){
            this.$i18n.locale = "en";
          }
          if(langUser == "简体中文 / S. Chinese"){
            this.$i18n.locale = "zh";
          }
          if(langUser == "繁體中文 / T. Chinese"){
            this.$i18n.locale = "zh_tw";
          }
          if(langUser == "한국어 / Korean"){
            this.$i18n.locale = "kor";
          }
          if(langUser == "日本語 / Japanese"){
            this.$i18n.locale = "jp";
          }
        },

        languageSelectChange(language) {
          let returnLanguage = '';

          if(language == 'zh') {
            returnLanguage = '简体中文 / S. Chinese';
          } else if (language == 'zh_tw') {
            returnLanguage = '繁體中文 / T. Chinese';
          } else if (language == 'kor') {
            returnLanguage = '한국어 / Korean';
          } else if (language == 'jp') {
            returnLanguage = '日本語 / Japanese';
          } else {
            returnLanguage = 'English';
          }

          return returnLanguage;
        },





      },


};
</script>
<style lang="less">

.active {
  background-color: #E8F0FE;
  color: #787A81 !important;
}

.checkLocalAccount {

  .has-error .ant-form-explain,
  .has-error .ant-form-split {
    text-align: left;
  }

  a:hover {
    background: #E8F0FE;
  }

  h2 {
    font-size: 13px;
    margin: 10px 0;
    // font-weight: bold;
  }

  h1 {
    font-size: 25px;
    margin: 10px 0;
    // font-weight: bold;
  }

  .me_icon {
    border-radius: 100%;
    float: left;
    position: relative;
    left: 50px;
    top: 3px;
    background: url("../../assets/img/login_me.png") no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    display: block;

  }

  .message_icon {
    float: left;
    position: relative;
    left: 0px;
    top: -5px;
    background-image: url("../../assets/img/login_message.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin: 10px 0px;

  }

  .authenticator_icon {
    float: left;
    position: relative;
    left: 0px;
    background-image: url("../../assets/img/Lock-Shield3.0.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 25px;
    height: 25px;
    display: inline-block;
    margin: 10px 0px;

  }

  .authenticator_1_icon {
    float: left;
    position: relative;
    left: 0px;
    background-image: url("../../assets/img/Paginate-Filter-1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 25px;
    height: 25px;
    display: inline-block;
    margin: 10px 0px;

  }

  .authenticator_2_icon {
    float: left;
    position: relative;
    left: 0px;
    background-image: url("../../assets/img/Paginate-Filter-2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 25px;
    height: 25px;
    display: inline-block;
    margin: 10px 0px;

  }

  .authenticator_3_icon {
    float: left;
    position: relative;
    left: 0px;
    background-image: url("../../assets/img/Paginate-Filter-3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 25px;
    height: 25px;
    display: inline-block;
    margin: 10px 0px;

  }

  .computer_icon {
    float: left;
    position: relative;
    left: 0px;;
    top: 0px;
    background-image: url("../../assets/img/login_computer.png");
    background-repeat: no-repeat;
    background-size: 150% 150%;
    background-position: left -6px top -7px;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin: 10px 0px;
  }
}


// #test1{
// }
// #login_login {
//   background: url(../../assets/img/login.png) no-repeat;
//   width: 100%;
//   height: 100vh;
//   background-size: 100% 100%;
// }
.rightContent {
  width: 350px;
  float: right;
  height: 100vh;
  background: #fff;
}

.rightContent-body {
  padding: 40px 25px 0px;
  margin-top: auto;
  margin-bottom: auto;
  height: 100%;
  background-color: #fff;
  position: relative;
  border-radius: 3px;
  text-align: center;
  overflow-y: auto;;
}

.rightContent-body .localAccount h1 {
  font-size: 30px;
  margin: 10px 0;
  font-weight: 700;
}

.rightContent-body .localAccount h2 {
  font-size: 20px;
  margin: 10px 0;
  font-weight: 700;
}

.con {
  text-align: center;
  width: 100%;
  display: table;
  height: 100vh;
  padding: 0;
}

.row {
  width: 100%;
  margin: 0;
  display: table-cell;
  vertical-align: middle;
}

.panel-default {
  padding: 40px 30px;
  margin-top: auto;
  margin-bottom: auto;
  height: 100%;
  background-color: #fff;
  position: relative;
  border-radius: 3px;

  .Langcheckout {
    position: absolute;
    top: -1px;
    right: -1px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  .panel-body {
    max-width: 380px;
    width: auto;
    margin: 0 auto;
    padding: 0;

    .panel-body-title {
      display: flex;
      align-items: center;
      justify-items: center;
      width: 190px;
      margin: 0 auto;

      .panel-body-titleR {
        font-family: Mv Boli;
        font-size: 22px;
        font-weight: 800;
      }

      .panel-body-titleL {
        margin: 0;
        height: 100px;
        width: 100px;
        display: block;
      }
    }

    .localAccount {

      .has-error .ant-form-explain,
      .has-error .ant-form-split {
        text-align: left;
      }

      h2 {
        font-size: 20px;
        margin: 10px 0;
        font-weight: bold;
      }

      h1 {
        font-size: 30px;
        margin: 10px 0;
        font-weight: bold;
      }
    }
  }
}
</style>